import React from "react";
import ResponsiveAppBar from "./ResponsiveAppBar";

const MainNavigation = (props) => {
  return (
       <ResponsiveAppBar/>
  );
};
export default MainNavigation;
